document.addEventListener('DOMContentLoaded', function() {


  
  // Initialize image link slider
  if (document.querySelector('.image-link-slider')) {
    $('.image-link-slider').slick({
      centerMode: true,
      arrows: true,
      infinite: true,
      dots: true,
      centerPadding: '10px',
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToScroll: 1,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            centerMode: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            infinite: true,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1
          }
        }
      ]
    });
  }

  // Your existing product slider initialization
  if (document.querySelector('.product-list.product-list--horizontal')) {
    $('.product-list.product-list--horizontal').slick({
      centerMode: true,
      arrows: true,
      infinite: true,
      dots: true,
      centerPadding: '10px',
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToScroll: 1,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
          }
        }
      ]
    });
  }



});


document.addEventListener("DOMContentLoaded", function () {
  // Sare anchors jinke andar aria-controls hai (submenu triggers)
  const menuTriggers = document.querySelectorAll(
    '.nav-dropdown__link[aria-controls]'
  );

  menuTriggers.forEach((trigger) => {
    const submenuId = trigger.getAttribute("aria-controls");
    const submenu = document.getElementById(submenuId);

    if (submenu) {
      const parentItem = trigger.closest(".nav-dropdown__item");

      // Trigger par click event
      trigger.addEventListener("click", function (e) {
        e.preventDefault();

        const isOpen = trigger.getAttribute("aria-expanded") === "true";

        // Sab close karne ke liye (multi open avoid)
        menuTriggers.forEach((t) => {
          const id = t.getAttribute("aria-controls");
          const sm = document.getElementById(id);
          if (sm) {
            sm.setAttribute("aria-hidden", "true");
            t.setAttribute("aria-expanded", "false");
          }
        });

        // Agar pehle se open nahi tha to open karo
        if (!isOpen) {
          submenu.setAttribute("aria-hidden", "false");
          trigger.setAttribute("aria-expanded", "true");
        }
      });
    }
  });

  // Outside click close
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".nav-dropdown__item")) {
      menuTriggers.forEach((trigger) => {
        const submenuId = trigger.getAttribute("aria-controls");
        const submenu = document.getElementById(submenuId);
        if (submenu) {
          submenu.setAttribute("aria-hidden", "true");
          trigger.setAttribute("aria-expanded", "false");
        }
      });
    }
  });
});


// Second part: nav items jinke paas dropdown hai
document.addEventListener("DOMContentLoaded", function () {
  const navItems = document.querySelectorAll(".nav-bar__item");

  navItems.forEach((item) => {
    const dropdown = item.querySelector("ul[aria-hidden]");

    if (dropdown) {
      const link = item.querySelector("a");

      if (link) {
        link.addEventListener("click", function (e) {
          e.preventDefault();

          const isOpen = dropdown.getAttribute("aria-hidden") === "false";

          // Sare dropdowns close karo
          navItems.forEach((i) => {
            const dd = i.querySelector("ul[aria-hidden]");
            if (dd) {
              dd.setAttribute("aria-hidden", "true");
            }
          });

          // Agar pehle se open nahi tha to open karo
          if (!isOpen) {
            dropdown.setAttribute("aria-hidden", "false");
          }
        });
      }
    }
  });

  // Outside click se close
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".nav-bar__item")) {
      navItems.forEach((item) => {
        const dropdown = item.querySelector("ul[aria-hidden]");
        if (dropdown) {
          dropdown.setAttribute("aria-hidden", "true");
        }
      });
    }
  });
});




// document.addEventListener("DOMContentLoaded", function () {
//   // Sare anchors jinke andar aria-controls hai (yaani submenu trigger hain)
//   const menuTriggers = document.querySelectorAll(
//     '.nav-dropdown__link[aria-controls]'
//   );

//   menuTriggers.forEach((trigger) => {
//     const submenuId = trigger.getAttribute("aria-controls");
//     const submenu = document.getElementById(submenuId);

//     if (submenu) {
//       // Parent <li> pe hover handle karo
//       const parentItem = trigger.closest(".nav-dropdown__item");

//       parentItem.addEventListener("mouseenter", function () {
//         submenu.setAttribute("aria-hidden", "false");
//         trigger.setAttribute("aria-expanded", "true");
//       });

//       parentItem.addEventListener("mouseleave", function () {
//         submenu.setAttribute("aria-hidden", "true");
//         trigger.setAttribute("aria-expanded", "false");
//       });
//     }
//   });
// });


// document.addEventListener("DOMContentLoaded", function () {
//   // Sare nav items jo dropdown rakhte hain unko lo
//   const navItems = document.querySelectorAll(".nav-bar__item");

//   navItems.forEach((item) => {
//     const dropdown = item.querySelector("ul[aria-hidden]");

//     if (dropdown) {
//       // Parent item par hover in
//       item.addEventListener("mouseenter", function () {
//         dropdown.setAttribute("aria-hidden", "false");
//       });

//       // Parent item se mouse nikalne par band
//       item.addEventListener("mouseleave", function () {
//         dropdown.setAttribute("aria-hidden", "true");
//       });
//     }
//   });
// });




